
export const MILESTONES = [
  'projectStart',
  'designStart',
  'schematicDesignCompletion',
  'designDevelopmentCompletion',
  'designCompletion',
  'constructionStart',
  'constructionCompletion',
  'projectCloseout',
];

export const NAMES = [
  'original',
  'projected',
  'actual',
  'designBaseline',
  'constructionBaseline',
  'clientExtendedBaseline',
];

export const CLIENT_ADJUSTABLE_MILESTONES = [
  'designCompletion',
  'constructionCompletion'
];

export function getMILESTONES (divisionName) {
  const list = [...MILESTONES];
  if (divisionName === 'Infrastructure') list.splice(3, 1);
  return list;
}

export function isClientAdjustable (milestone) {
  return CLIENT_ADJUSTABLE_MILESTONES.indexOf(milestone) !== -1;
}
